import { Controller } from 'stimulus';
import toArray from '@/helpers/toArray';

class UserController extends Controller {
  connect() {
    this.filter();
  }

  onFilterClick(e) {
    e.preventDefault();

    this.filter();
  }

  filter() {
    const filters = toArray(this.filterTarget.querySelectorAll('select, input'));
    const data = {};

    filters.forEach((filter) => {
      data[filter.name] = filter.value;
    });

    $.ajax({
      url: this.filterTarget.action,
      method: 'POST',
      data,
      success: (res) => {
        this.outputUsers(res.users);
        this.outputCount(res.count);
      },
      error: () => {
        // console.error(err);
      },
    });
  }

  outputUsers(users) {
    $(this.outputTarget).html('');
    $(this.outputTarget).html($(users).html());
  }

  outputCount(count) {
    this.countTarget.innerText = count;
  }
}

UserController.targets = [
  'output',
  'filter',
  'count',
];

export default UserController;
